import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import PageView from '../PageView';
import MasterbrandHeader from '../MasterbrandHeader';
import QueryHandler from './QueryHandler';
import routes from '../../../routes';
import Meta from './Meta';

if (process.browser) require('./App.scss');

// On browser back - read the scrollTop that is stored, and scroll to it.
const onPopState = (event) => {
  const { state } = event.state || {};
  if (state && Object.prototype.hasOwnProperty.call(state, 'scrollTop')) {
    // The render is synchronous, so this pushes it to after render completes.
    setTimeout(() => window.scrollTo(0, state.scrollTop), 0);
  }
};

class AppContainer extends Component {
  componentDidMount() {
    document.addEventListener('popstate', onPopState);

    // Allows to tests to wait for app bootstrapping.
    window.APP_READY = true;
  }

  render() {
    return (
      <div>
        <Meta />
        <PageView />
        <MasterbrandHeader />
        <QueryHandler />
        <Switch>
          {routes.map(route => <Route key={route.path} {...route} />)}
        </Switch>
      </div>
    );
  }
}

export default AppContainer;



// WEBPACK FOOTER //
// ./src/universal/ui/components/App/App.js